import React from 'react';
import '../allcss/imagecard.css';
import image11 from '../Asets/image11.jpeg';
import image12 from '../Asets/image12.jpeg';
import image13 from '../Asets/image13.jpeg';

const ImageCard = ({ imageSrc, title, description }) => (
  
  <div className="imagecard-card">
    <div className="imagecard-image-wrapper">
      <img src={imageSrc} alt={title} className="imagecard-image" />
    </div>
    <div className="imagecard-content-wrapper">
      <h2 className="imagecard-title">{title}</h2>
      <p className="imagecard-description">{description}</p>
    </div>
  </div>
);

const ImageCardsSection = () => {
  const cardData = [
    {
      imageSrc: image11,
      title: 'Personalized Learning with Individual Attention',
      description:
        'We believe every child deserves individual attention and encouragement. Our small class sizes help educators nurture confidence, creativity, and essential life skills through engaging, hands-on learning experiences.',
    },
    {
      imageSrc: image12,
      title: 'Building Strong Foundations for Life',
      description:
        'Our thoughtfully designed curriculum encourages children to learn through exploration, creativity, and meaningful experiences. Every activity supports cognitive, social, emotional, and physical development in a safe and engaging environment.',
    },
    {
      imageSrc: image13,
      title: 'Building Confident & Compassionate Children ',
      description:
        'We nurture confidence, kindness, respect, and responsibility through everyday learning experiences. Our value-based approach helps children develop strong character, positive relationships, and the life skills they need to grow into confident individuals."',
    },
  ];

  return (
    
    <div id="learn-more" className="imagecard-section">
      {cardData.map((card, index) => (
        <ImageCard
          key={index}
          imageSrc={card.imageSrc}
          title={card.title}
          description={card.description}
        />
      ))}
    </div>
  );
};

export default ImageCardsSection;
